export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = "04cebc2b-488e-43af-8a6e-5dd0f7c9f869";
export const MODAL_CLOSE_SEC = 2.5;
